import {CALL_API} from 'redux-api-middleware';
import {
  API_CONTEXT_GET_REQUEST,
  API_CONTEXT_GET_SUCCESS,
  API_CONTEXT_GET_FAILURE,
  API_TASK_COMPLETE_REQUEST,
  API_TASK_COMPLETE_SUCCESS,
  API_TASK_COMPLETE_FAILURE,
  API_TASK_ASSIGN_POST_REQUEST,
  API_TASK_ASSIGN_POST_SUCCESS,
  API_TASK_ASSIGN_POST_FAILURE,
  API_TASK_UNASSIGN_REQUEST,
  API_TASK_UNASSIGN_SUCCESS,
  API_TASK_UNASSIGN_FAILURE,
  API_TASK_UPDATE_POST_REQUEST,
  API_TASK_UPDATE_POST_SUCCESS,
  API_TASK_UPDATE_POST_FAILURE,
} from 'common/types';
import {ENDPOINT_WORKFLOW_TASK} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

export default {
  getContext: (token, id) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_WORKFLOW_TASK}${id}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_CONTEXT_GET_REQUEST,
          API_CONTEXT_GET_SUCCESS,
          API_CONTEXT_GET_FAILURE,
        ],
      },
    };
  },

  assignTask: (id, token) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_WORKFLOW_TASK}${id}/assignments`,
        headers: commonJwtHeader(),
        method: 'POST',
        types: [
          API_TASK_ASSIGN_POST_REQUEST,
          API_TASK_ASSIGN_POST_SUCCESS,
          API_TASK_ASSIGN_POST_FAILURE,
        ],
      },
    };
  },

  unassignTask: (token, id) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_WORKFLOW_TASK}${id}/assignments`,
        headers: commonJwtHeader(),
        method: 'DELETE',
        types: [
          API_TASK_UNASSIGN_REQUEST,
          API_TASK_UNASSIGN_SUCCESS,
          API_TASK_UNASSIGN_FAILURE,
        ],
      },
    };
  },

  // password optional for tasks that require auth on completion
  completeTask: (id, payload, token, password) => {
    var headers = commonJwtHeader();
    headers['x-taskauth-password'] = password;
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_WORKFLOW_TASK}${id}/complete`,
        headers: headers,
        body: payload,
        method: 'PUT',
        types: [
          API_TASK_COMPLETE_REQUEST,
          {
            type: API_TASK_COMPLETE_SUCCESS,
            meta: (action, state, res) => {
              if (res) {
                return {
                  status: res.status,
                  statusText: res.statusText,
                };
              } else {
                return {
                  status: 'Network request failed',
                };
              }
            },
          },
          {
            type: API_TASK_COMPLETE_FAILURE,
            meta: (action, state, res) => {
              if (res) {
                return {
                  status: res.status,
                  statusText: res.statusText,
                };
              } else {
                return {
                  status: 'Network request failed',
                };
              }
            },
          },
        ],
      },
    };
  },
};
